module.exports = __webpack_public_path__ + "static/media/seoul_innovation.bacc13bb.png";